module.exports = __webpack_public_path__ + "img/banner.527b43be.jpg";